'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _react = require('react');
var React = _interopRequireWildcard(_react);
var _reactDraggable = require('react-draggable');
var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function cloneElement(element, props) {
  if (props.style && element.props.style) {
    props.style = (0, _extends3['default'])((0, _extends3['default'])({}, element.props.style), props.style);
  }
  if (props.className && element.props.className) {
    props.className = element.props.className + ' ' + props.className;
  }
  return React.cloneElement(element, props);
}
var Resizable = function (_React$Component) {
  (0, _inherits3['default'])(Resizable, _React$Component);
  function Resizable() {
    (0, _classCallCheck3['default'])(this, Resizable);
    var _this = (0, _possibleConstructorReturn3['default'])(this, (Resizable.__proto__ || Object.getPrototypeOf(Resizable)).apply(this, arguments));
    _this.handleDrag = function (event) {
      event.stopPropagation();
      event.preventDefault();
    };
    _this.saveDraggable = function (draggable) {
      _this.draggable = draggable;
    };
    _this.handleStop = function (event, dragCallbackData) {
      var onResize = _this.props.onResize;
      if (onResize) {
        onResize(event, dragCallbackData);
      }
      if (_this.draggable) {
        _this.draggable.setState({
          x: 0,
          y: 0
        });
      }
    };
    return _this;
  }
  (0, _createClass3['default'])(Resizable, [{
    key: 'render',
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _a = this.props,
        children = _a.children,
        p = __rest(_a, ["children"]);
      var className = p.className ? p.className + ' react-resizable' : 'react-resizable';
      var subchildren = children.props.children;
      // What we're doing here is getting the child of this element, and cloning it with this element's props.
      // We are then defining its children as:
      // Its original children (resizable's child's children), and
      // A draggable handle.

      return cloneElement(children, {
        className: className,
        children: [subchildren, React.createElement(_reactDraggable2['default'], {
          ref: this.saveDraggable,
          axis: 'x',
          key: 'resizableHandle',
          onDrag: this.handleDrag,
          onStop: this.handleStop
        }, React.createElement('span', {
          className: 'column-resizable-handle'
        }))]
      });
    }
  }]);
  return Resizable;
}(React.Component);
exports['default'] = Resizable;
module.exports = exports['default'];